import {useParams} from "react-router-dom";
import {useConcelloAuth} from ".";

const ConcelloAuthRequired = ({children}) => {
    const {checkAllowed, isConcelloUser, isSupramunicipalUser} = useConcelloAuth();

    const {codigo} = useParams();

    return ((isConcelloUser() && checkAllowed(codigo))) ||  (isSupramunicipalUser() && checkAllowed(codigo)) || (!isConcelloUser() && !isSupramunicipalUser()) ? (
        <>{children}</>
    ) : null;
};


export default ConcelloAuthRequired;
